import React, { useEffect, useState } from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import TitleMain from "../../components/Title/TitleMain";
import CardGrid from "../../components/Card/CardGrid";
import CardComing from "../../components/Card/CardComing";
import {useModal} from "../../contexts/ModalContext";
import {getActivitesApi, getActivitesLocal} from "../../services/ActivitesService";
import CardSimple from "../../components/Card/CardSimple";
import {useUser} from "../../contexts/UserContext";
import FilterHamburger from "../../components/Filter/FilterHamburger";
import {faDownLong, faUpLong} from "@fortawesome/free-solid-svg-icons";
import {getTypesActivites} from "../../services/SeanceService";
import {applyFiltersAndSort} from "../../services/FilterService";
import loginForm from "../../components/Login/LoginForm";
import DateService from "../../services/DateService";

const uriFilterName = "filter";

function ActivitesPage() {
    const { user } = useUser();
    const location = useLocation();
    const [ activites, setActivites ] = useState([]);
    const [ title, setTitle ] = useState("En cours de chargement...");
    const { showModal, hideModal } = useModal();
    const params = new URLSearchParams(location.search);
    const [types, setTypes] = useState([]);
    const navigate = useNavigate();

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const handleFilterSubmit = (filters) => {
        const filterValues = Object.entries(filters)
            .filter(([key, val]) => val)
            .map(([key]) => key)
            .join(',');

        updateURLParams(uriFilterName, filterValues);
    };

    const handleSortSubmit = (sort) => {
        updateURLParams('sort', sort.sortOptions);
    };

    const updateURLParams = (type, value) => {
        switch (type) {
            case 'filter':
                if (value) {
                    params.set(uriFilterName, value);
                } else {
                    params.delete(uriFilterName);
                }
                break;
            case 'sort':
                params.set('sort', value);
                break;
            default:
                break;
        }

        navigate(`${location.pathname}?${params.toString()}`);
    };

    useEffect(() => {
        (async () => {
            let endpoint = '';
            switch (location.pathname) {
                case '/activites':
                case '/activites/':
                    endpoint = '/';
                    setTitle("Activités dans mon entreprise");
                    break;
                case '/activites/myCompany':
                    endpoint = '/myCompany';
                    setTitle("Activités dans mon entreprise");
                    break;
                case '/activites/disponibles':
                    endpoint = '/disponibles';
                    setTitle("Activités disponibles");
                    break;

                default:
                    setTitle("Page non trouvée");
                    return;
            }

            if (endpoint) {
                const response = await getTypesActivites();
                setTypes(response.types);

                const params = new URLSearchParams(location.search);

                const rez = await applyFiltersAndSort(params, "/activites");
                if (rez) {
                    setActivites(rez.activites);
                }
            }
        })().catch(error => {
            console.error("Erreur lors de la récupération des données :", error);
            handleError();
        });
    }, [location.search]);

    useEffect(() => {
        let myTypes = [];
        for (const type of types) {
            for (const activite of activites) {
                if (activite.type.id === type["value"]) {
                    myTypes.push(type);
                    break;
                }
            }
        }
        setTypes(myTypes);
    }, [activites]);

    const cardsData = activites.map(activite => ({
        id: activite.id,
        lien: "/activites/activite/" + activite.id,
        image: activite.type.image ?? "",
        titre: activite.type.nom,
        userRegistered: activite.userRegistered,
        userRegisteredLabel: activite.userRegisteredLabel ?? "",
        userNonRegisteredLabel: activite.userNonRegisteredLabel ?? "",
        rows: [
            "Date : " + DateService.formatFrenchDateWithoutTime(activite.date_start) + " au " + DateService.formatFrenchDateWithoutTime(activite.date_end)
        ],
    }));

    return (
        <div className="content">
            <TitleMain text="Activités dans mon entreprise" />

            <FilterHamburger
                labelFilter={"Type de séance"}
                labelSort={"Trier par"}
                data={types}
                dataSort={[
                    /*
                    { value: 'nom', label: 'Nom croissant', next: "nomDesc", icon: faUpLong },
                    { value: 'nomDesc', label: 'Nom décroissant', next: "nom", icon: faDownLong },
                     */
                    {value: 'date', label: 'Date croissante', next: "dateDesc", icon: faUpLong},
                    {value: 'dateDesc', label: 'Date décroissante', next: "date", icon: faDownLong}
                ]}
                onFilterSubmit={handleFilterSubmit}
                onSortSubmit={handleSortSubmit}
                sortOptionFromUrl={params.get('sort')}
                filterOptionFromUrl={params.get(uriFilterName)}
            />

            <CardGrid cards={cardsData} CardComponent={CardSimple} />
        </div>
    )
}

export default ActivitesPage;
